<template>
    <div class="cart-bottom">
        <p class="accept-methods">
            <span>{{ $t('cart.bottom.accept') }}</span>
            <template v-if="FEATURE('cloud.paypal')">
                <img class="cn-payment" v-for="(item, index) in paymentMethods.cn" :key="index" :src="item" alt="">
            </template>
            <img v-else v-for="(item, index) in paymentMethods.all" :key="index" :src="`https://cdn.reolink.com/wp-content/uploads/2016/10/${item}.png`" :alt="$t(`cart.credict_cart.${index}`)" :title="$t(`cart.credict_cart.${index}`)">
        </p>
        <div class="security-content-wrap">
            <div class="flex security-content">
                <div>
                    <i class="icon-icon2_security security-icon"></i>
                </div>
                <div>
                    <h3 class="security-title">{{ $t('cart.bottom.ssl') }}</h3>
                    <p class="security-des">{{ $t('cart.bottom.security') }}</p>
                    <p class="privacy" v-html="$t('cart.bottom.privacy', {
                        privacy: getOfficialUrl( config.privacy )
                    })"></p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import paymentMethods from '@/config/paymentMethods';
import { config } from 'CONFIG';

export default {
    data () {

        return {

            paymentMethods,
            config

        };

    }
};
</script>

<style lang="less">
    @s-color: #007400;
    .reo-cart{
        .cart-nav{
            margin-bottom: 0.5rem;
        }
        @media @mobile {
            .cart-nav{
                display: none;
            }
        }
        .cart-bottom{
            padding-top: 0.2rem;
            border-top: 1px solid #ddd;
            @media @mobile {
                padding: 0;
                border: none;
            }
            .accept-methods{
                font-size: 0.16rem;
                color: #777;
                margin-bottom: 0.25rem;
                @media @mobile {
                    border-top: 1px solid #ddd;
                    font-size: 0.26rem;
                    margin: 0 15px;
                    padding: 0.35rem 0;
                }
                span{
                    margin-right: 0.2rem;
                    display: inline-block;
                }
                img{
                    vertical-align: middle;
                    @media @mobile{
                        max-width: 66px;
                        width: 0.65rem;
                    }
                }
                img.cn-payment {
                    height: 20px;
                    @media @mobile {
                        width: auto;
                        max-width: unset;
                        height: .4rem;
                    }
                }
                img+img{
                    margin-left: 0.1rem;
                }
            }
            .security-icon{
                color: @s-color;
                font-size: 0.5rem;
                margin-right: 0.15rem;
                @media @mobile{
                    font-size: 0.6rem;
                }
            }
            .security-title{
                color: @s-color;
                font-size: 0.14rem;
                line-height: 1;
                @media @mobile{
                    font-size: 0.26rem;
                    margin-bottom: 0.1rem;
                }
            }
            .security-des{
                @media @mobile{
                    font-size: 0.22rem;
                    color: #DEDEDE;
                    font-weight: 300;
                }
            }
            .privacy{
                color: #777;
                margin-top: 0.05rem;
                @media @mobile{
                    font-size: 0.22rem;
                    font-weight: 300;
                    margin-top: .1rem;
                }
            }
            @media @mobile {
                .security-content{
                    border-bottom: 1px solid #878787;
                    padding: 0.6rem 0 0.35rem;
                }
                .security-content-wrap{
                    background-color: #2B2B2B;
                    padding: 0 15px;
                    color: #fff;
                }
            }
        }
    }
    .body.app-not-show .security-content-wrap{
        padding-bottom: 1rem;
    }
</style>



// WEBPACK FOOTER //
// src/components/cartBottom.vue